import { defineAsyncComponent } from 'vue';
export default defineAsyncComponent(function () {
    return import(
    /* webpackChunkName: "itineraryFields" */
    './ItineraryFieldsComponent.vue');
});
